@use "Static/icons/icomoon/style.scss";

:host {
    line-height: 1;
}
